import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useAuth } from '../../context/AuthContext';
import { useFetch } from '../../hooks/useFetch';

const TITLES = {
  '/dashboard':           'Dashboard',
  '/products':            'Finished Goods',
  '/raw-materials':       'Raw Materials',
  '/bom':                 'Bill of Materials',
  '/vendors':             'Vendors',
  '/sales-orders':        'Sales Orders',
  '/backorders':          'Backorders',
  '/rma':                 'Returns / RMA',
  '/work-orders':         'Work Orders',
  '/purchase-orders':     'Purchase Orders',
  '/receiving':           'Receiving Log',
  '/kits':                'Kits & Bundles',
  '/adjustments':         'Inventory Adjustments',
  '/forecast':            'Forecast',
  '/alerts':              'Alerts',
  '/reports/valuation':   'Inventory Valuation',
  '/reports/margin':      'Gross Margin',
  '/reports/shrinkage':   'Shrinkage',
  '/reports/reorder':     'Reorder Cost Forecast',
  '/reports/weekly':               'Weekly Report',
  '/reports/upcoming-deliveries':  'Upcoming Deliveries',
  '/integrations':        'Integrations',
  '/ai':                  'AI Admin Panel',
  '/users':               'Users',
  '/settings':            'Settings',
};

export default function AppLayout() {
  const { user, loadSettings } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { data: dashData } = useFetch('/api/dashboard');

  useEffect(() => { loadSettings(); }, [loadSettings]);
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  if (!user) return <Navigate to="/login" replace />;

  // Force password change
  if (user.mustChangePassword && location.pathname !== '/settings/profile') {
    return <Navigate to="/settings/profile" replace />;
  }

  const title = TITLES[location.pathname] || 'StockForge';

  return (
    <div className="app-layout">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        stats={dashData?.metrics}
      />
      <div className="main-content">
        <Topbar title={title} onMenuClick={() => setSidebarOpen(true)} />
        <main className="page-body">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
